import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';
import { FailedDhcpResolution, SuccessfulDhcpResolution } from '../../../../types/types';
import { green, orange, red } from '@mui/material/colors';

interface PartialConflictResolutionResultProps {
  succeeded: SuccessfulDhcpResolution[];
  failed: FailedDhcpResolution[];
}

const PartialConflictResolutionResult: React.FC<PartialConflictResolutionResultProps> = ({
  succeeded,
  failed,
}) => {
  return (
    <>
      <WarningIcon sx={{ fontSize: 50, color: orange[500], marginTop: 1 }} />
      <Stack spacing={2}>
        <Typography variant="body1">Your action was partially successful.</Typography>
        <Box>
          <Typography variant="body2" fontWeight="bold" color={green[700]}>
            Succeeded
          </Typography>
          {succeeded.map((s, index) => (
            <Box key={`${s.status}-${index}`}>
              <Typography variant="body2">
                <Box component="span" fontWeight="bold">
                  DHCP {s.status} -
                </Box>
                {` IP: ${s.data.ip}, MAC: ${s.data.mac}, host: ${s.data.host}`}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box>
          <Typography variant="body2" fontWeight="bold" color={red[700]}>
            Failed
          </Typography>
          {failed.map((f, index) => (
            <Box key={`${f.status}-${index}`}>
              <Typography variant="body2">
                <Box component="span" fontWeight="bold">
                  DHCP not {f.status} -
                </Box>
                <Box component="span" color="text.secondary">
                  {` error: ${f.error}`}
                </Box>
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </>
  );
};

export default PartialConflictResolutionResult;
